


// import React, { useState } from 'react';
// import { FaArrowLeft } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate
// import MIndianProfileForm from './MIndianProfileForm';
// import MForeignProfileForm from './MForeignProfileForm';

// function MProfileComponent() {
//   const [formType, setFormType] = useState('Indian'); 
//   const navigate = useNavigate(); 

//   const handleBack = () => {
//     navigate(0);
//   };
//   return (
//     <div className="w-full h-auto  bg-gray-100">
//       {/* Header Section */}
//       <div className="w-full bg-[#FF9630] text-white py-4 px-6 flex items-center">
//         <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
//           <FaArrowLeft className="text-lg" />
//         </button>
//         <h1 className="text-xl font-semibold">My Profile</h1>
//       </div>

//       {/* Main Content */}
//       <div className="flex justify-center ">
//         {/* Outer Container */}
//         <div className="w-full max-w-2xl border rounded-lg bg-white shadow-lg">
//           {/* Card Structure */}
//           <div className="rounded-lg p-6">
//             {/* Radio buttons for Indian and Foreigner */}
//             <div className="flex items-center space-x-6 mb-6">
//               <div className="flex items-center space-x-2">
//                 <input
//                   type="radio"
//                   id="indian"
//                   name="profileType"
//                   checked={formType === 'Indian'}
//                   onChange={() => setFormType('Indian')}
//                   className="form-radio"
//                 />
//                 <label htmlFor="indian" className="font-semibold text-gray-600">
//                   Indian
//                 </label>
//               </div>

//               <div className="flex items-center space-x-2">
//                 <input
//                   type="radio"
//                   id="foreigner"
//                   name="profileType"
//                   checked={formType === 'Foreigner'}
//                   onChange={() => setFormType('Foreigner')}
//                   className="form-radio"
//                 />
//                 <label htmlFor="foreigner" className="font-semibold text-gray-600">
//                   Foreigner
//                 </label>
//               </div>
//             </div>

//             {/* Conditionally render the form based on selected type */}
//             {formType === 'Indian' ? <MIndianProfileForm /> : <MForeignProfileForm />}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MProfileComponent;

import React, { useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import MIndianProfileForm from './MIndianProfileForm';
import MForeignProfileForm from './MForeignProfileForm';

function MProfileComponent() {
  const [formType, setFormType] = useState('Indian'); 
  const navigate = useNavigate(); 

  const handleBack = () => {
    navigate(0);
  };

  return (
    <div className="w-full h-screen flex flex-col">
      {/* Header Section */}
      <div className="w-full bg-[#FF9630] text-white py-4 px-6 flex items-center">
        <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
          <FaArrowLeft className="text-lg" />
        </button>
        <h1 className="text-xl font-semibold">My Profile</h1>
      </div>

      {/* Main Content */}
      <div className="flex justify-center flex-grow overflow-y-auto">
        {/* Outer Container */}
        <div className="w-full max-w-2xl  my-4">
          {/* Card Structure */}
          <div className="rounded-lg p-6">
            {/* Radio buttons for Indian and Foreigner */}
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center space-x-2">
                <input
                  type="radio"
                  id="indian"
                  name="profileType"
                  checked={formType === 'Indian'}
                  onChange={() => setFormType('Indian')}
                  className="form-radio"
                />
                <label htmlFor="indian" className="font-semibold text-gray-600">
                  Indian
                </label>
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="radio"
                  id="foreigner"
                  name="profileType"
                  checked={formType === 'Foreigner'}
                  onChange={() => setFormType('Foreigner')}
                  className="form-radio"
                />
                <label htmlFor="foreigner" className="font-semibold text-gray-600">
                  Foreigner
                </label>
              </div>
            </div>

            {/* Conditionally render the form based on selected type */}
            {formType === 'Indian' ? <MIndianProfileForm /> : <MForeignProfileForm />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MProfileComponent;
